import { render } from "./LoginPage.vue?vue&type=template&id=86840590&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=86840590&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86840590"]])

export default __exports__